import React, { useState, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import './ZoomLevel.scss'; // Import the CSS file for styling

interface ZoomLevelProps {
  map: mapboxgl.Map;
}

const ZoomLevel: React.FC<ZoomLevelProps> = ({ map }) => {
  const [zoomLevel, setZoomLevel] = useState(map.getZoom());

  useEffect(() => {
    const handleZoom = () => {
      setZoomLevel(map.getZoom());
    };

    map.on('zoom', handleZoom);

    // Clean up the event listener on component unmount
    return () => {
      map.off('zoom', handleZoom);
    };
  }, [map]);

  return (
    <div title='Shows the current zoom level of the map' className="zoom-level map-control">
      <span >{zoomLevel.toFixed(2)}</span>
    </div>
  );
};

export default ZoomLevel;